import { motion } from "framer-motion";
import { personal, stats } from "@/data/portfolio";

export default function About() {
  return (
    <section id="about" className="section about" data-testid="about-section">
      <div className="about__grid">
        <div className="about__left">
          <span className="overline">◆ About — 01 / 02</span>
          <h2 className="about__title serif" data-testid="about-heading">
            Two crafts.
            <br />
            <span className="italic">One</span> obsession:
            <br />
            <span className="accent">attention</span>.
          </h2>
        </div>

        <div className="about__right">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="about__lede"
            data-testid="about-bio"
          >
            {personal.shortBio}
          </motion.p>

          <div className="about__discipline" data-testid="about-disciplines">
            <Discipline
              no="01"
              title="Graphic Design"
              body="Editorial-grade craft applied to commercial outcomes — thumbnails, social creatives, brochures and campaign kits where clarity beats decoration and CTR follows."
            />
            <Discipline
              no="02"
              title="Community Management"
              body="Discord builds, moderation frameworks, custom bots and engagement loops. I've scaled creator communities past 90,000 members and kept them healthy."
            />
          </div>

          <div className="about__stats" data-testid="about-stats">
            {stats.map((s) => (
              <div key={s.label} className="stat">
                <div className="stat__value serif">{s.value}</div>
                <div className="stat__label">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

function Discipline({ no, title, body }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7 }}
      className="discipline"
    >
      <div className="discipline__no overline">{no}</div>
      <h3 className="discipline__title serif italic">{title}</h3>
      <p className="discipline__body">{body}</p>
    </motion.div>
  );
}
